import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

export const useJoyaAuthorization = (options = {}) => {
  const res = useMutation(
    async (dto) =>
      http.put(HTTP_ENDPOINTS.joyaIntegration.putJoyaAuthorization(), dto),
    { ...options, select: (data) => data.data.data },
  );

  return res;
};
